module.exports = __webpack_public_path__ + "main/assets/public/player/plus-icon.af4b896aeccbbf4a.svg";